import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {UserChallengeComponent} from "./user-challenge.component";
import { UserMenuSectionBox } from "../user-menu/boxes/user-menu-section.box";

@observer
export class UserChallengesComponent extends OrbitComponent {
  render() {
    const drawerBoxesConfig = (this.services.configuration.data.drawer.drawerBoxes || [])
                              .filter(configData => configData.display);

    return (
      <>
        {drawerBoxesConfig.map(configData =>
            <UserMenuSectionBox key={configData.text} className={configData.class}>
              <UserChallengeComponent configData={configData}/>
            </UserMenuSectionBox>
        )}
      </>
    );
  }
}
